import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Parse a UTC date string without timezone conversion.
 * Server sends dates like "2026-02-12T09:00:00.000Z" but we want to display
 * the time as-is (09:00), not converted to local timezone (10:00 in Belgium).
 */
export function parseUTCDate(dateString) {
  if (!dateString) return null;
  const d = new Date(dateString);
  // Create a new date using UTC components to avoid timezone conversion
  return new Date(
    d.getUTCFullYear(),
    d.getUTCMonth(),
    d.getUTCDate(),
    d.getUTCHours(),
    d.getUTCMinutes(),
    d.getUTCSeconds()
  );
}
